import moment from "moment";

const scheduleReloadTimeout = (schedule, serverTime) => {

    let reloadTimeout = null;
    const nowServerTime = moment(serverTime);
    const {
        joiningStartDate,
        joiningEndDate,
        opinionStartDate,
        opinionEndDate,
        submissionStartDate,
        submissionEndDate,
        swzOpinionStartDate,
        swzOpinionEndDate,
        collectingDataStartDate,
        collectingDataEndDate
    } = schedule;
    const dates = [joiningStartDate, joiningEndDate, opinionStartDate, opinionEndDate, submissionStartDate, submissionEndDate];
    for (let date of dates) {
        if (date && moment(date).isAfter(nowServerTime)) {
            reloadTimeout = moment(date).diff(nowServerTime) + 500;
            break;
        }
    }

    if(!reloadTimeout) {
        const dates2 = [swzOpinionStartDate, swzOpinionEndDate, collectingDataStartDate, collectingDataEndDate];
        for (let date of dates2) {
            if (date && moment(date).isAfter(nowServerTime)) {
                if(!reloadTimeout ||  (moment(date).diff(nowServerTime) + 500) < reloadTimeout) {
                    reloadTimeout = moment(date).diff(nowServerTime) + 500;
                }
            }
        }
    }


    if (reloadTimeout && reloadTimeout > 3600000) {
        reloadTimeout = null;
    }
    return reloadTimeout;

}

export default scheduleReloadTimeout;